var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v(_vm._s(_vm.$t("alarms.title")))]),_c('v-divider'),_c('alarm-list',{attrs:{"no-fetch":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }